import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { PAGE_BANNERS } from "../data/content";

export default function ComingSoon({ title }) {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.resources} alt={title} fallbackKey="resources" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>{title}</h1>
          <p className="italic text-[#7d8e54]">Coming soon!</p>
          <p>
            Please check back later. In the meantime, feel free to{" "}
            <a className="nn-link" href="/contact">
              contact us
            </a>{" "}
            with any questions.
          </p>
        </article>
      </div>
    </div>
  );
}
